<template>
	<div>
		<div>
			<vx-card title="Workers" class="mb-5">
				<vs-table search stripe max-items="50" no-data-text="No Workers" pagination :data="workerList">
					<template slot="header"></template>
					<template slot="thead">
						<vs-th sort-key="WorkerName">Worker</vs-th>
						<vs-th v-if="isAdmin">Email</vs-th>
					</template>
					<template slot-scope="{data}">
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td :data="tr.WorkerName">{{ tr.WorkerName }}</vs-td>
							<vs-td v-if="isAdmin" :data="tr.Email">{{ tr.Email }}</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vx-card>
		</div>
	</div>
</template>


<script>

const moment = require('moment')

export default {
  data () {
    return {}
  },
  computed: {
    userLoggedIn () {
      return this.$store.getters.GetUserLoggedIn
    },
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    workerList () {
      return this.$store.getters.GetWorkerList
    }
  },
  watch : {
    userLoggedIn (loggedIn) {
      if (loggedIn) {
        this.OnLoggedIn()
      }
    }
  },
  methods: {
    OnLoggedIn () {
      const startDay = moment()
      const day = startDay.day()
      let diff = 1
      if (day === 0 || day === 1) diff = day + 2
      startDay.subtract(diff, 'days')
      if (startDay.day() === 5) {
        this.fromDate = startDay.format('YYYY-MM-DD')
        this.toDate = moment().format('YYYY-MM-DD')
      } else {
        this.fromDate = startDay.format('YYYY-MM-DD')
        this.toDate = startDay.format('YYYY-MM-DD')
      }

      this.$store.dispatch('ActionFetchGlobalData')
    }
  },
  mounted () {
    if (this.userLoggedIn) {
      this.OnLoggedIn()
    }
  }
}

</script>

